import React from 'react';
import { Truck } from 'lucide-react';

// Thin promo bar shown at the very top of every page.
// NOTE: keep the "200 €" here in sync with DELIVERY_FREE_THRESHOLD on the backend.
const AnnouncementBar: React.FC = () => (
    <div className="bg-primary-600 text-white">
        <div className="container mx-auto px-4 py-2 flex items-center justify-center gap-2 text-center">
            <Truck className="h-4 w-4 flex-shrink-0" aria-hidden="true" />
            <span className="text-xs sm:text-sm font-medium tracking-wide">
                Безплатна доставка за поръчки над 200 €
            </span>
        </div>
    </div>
);

export default AnnouncementBar;
